var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "landing", class: `landing_background_${_vm.background}` },
    [
      _vm.stepLayout
        ? _c(
            "div",
            { staticClass: "landing__layout container-fluid" },
            [
              _vm._l(_vm.stepLayout, function (layoutItem, index) {
                return [
                  _c(
                    layoutItem.component,
                    _vm._g(
                      _vm._b(
                        { key: index, tag: "component" },
                        "component",
                        _vm.layoutComponentsProps[layoutItem.component],
                        false
                      ),
                      layoutItem.handlers
                    )
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }